import * as React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'common/components/IconFont';
import { Menu } from 'antd';
import type { Shortcut, ShortcutsConfig } from './type';
import { connect } from 'react-redux';
const SubMenu = Menu.SubMenu;

interface iProps {
    className?: string;
    config?: ShortcutsConfig;
    roleType?: string;
    mobile?: boolean;
    visibleKeys?: string[];
    notice?: {
        data: any[];
        totalCounts: number;
    };
}

const mapStateToProps = (state: any) => ({
    notice: state.notice.get('noticeOverview'),
});

@(connect(mapStateToProps) as any)
export default class Shortcuts extends React.Component<iProps> {
    renderSubmenu = (item: any) => {
        const { notice } = this.props;
        let { key, title, children, className } = item;
        if (key === 'NOTICE') {
            title = title(notice?.totalCounts || 0);
            children = children(notice?.data || [], notice?.totalCounts || 0);
        }
        return (
            <SubMenu key={key} title={title} className={className} popupClassName={key}>
                {children.map(({ key, title, path, icon }: Shortcut) => (
                    <Menu.Item key={key}>
                        {path ? (
                            <Link to={path}>
                                <Icon className={`anticon-${icon}`} />
                                <span>{title}</span>
                            </Link>
                        ) : (
                            title
                        )}
                    </Menu.Item>
                ))}
            </SubMenu>
        );
    };

    render() {
        const { className, config, roleType, mobile, visibleKeys } = this.props;
        const shortcuts = visibleKeys ? config.filter(({ key }) => visibleKeys.includes(key)) : config;
        return (
            <div className={className}>
                <Menu mode="horizontal" selectedKeys={[]} triggerSubMenuAction={mobile ? 'click' : 'hover'}>
                    {shortcuts.map(({ key, title, path, children }: Shortcut) =>
                        children ? (
                            this.renderSubmenu({
                                key,
                                title,
                                path,
                                children,
                                className: `${key} ${roleType}`,
                            })
                        ) : (
                            <Menu.Item key={key} className={key}>
                                {path ? <Link to={path}>{title}</Link> : title}
                            </Menu.Item>
                        ),
                    )}
                </Menu>
            </div>
        );
    }
}
